export default {
  list: { lazy: () => import('./inverterComponents'), component: 'ComponentInverterList' },
  edit: { lazy: () => import('./inverterComponents'), component: 'ComponentInverterEdit' },
  create: { lazy: () => import('./inverterComponents'), component: 'ComponentInverterCreate' },
}
